<br />
<br />
<br />
<br />
<div class="container-fluid page-wrapper py-5" *ngIf="article">

  <!-- Header -->
  <div class="text-center row mb-5">
    <h2 class="main-header mb-4" #mainHeader>
      {{ displayTitle }}
    </h2>
    <p class="sub-header">
      {{ displaySubtitle }}
    </p>
  </div>

  <div class="sections-wrapper d-flex flex-column gap-5">

    <div *ngFor="let section of displaySections; let i = index" class="section-row row align-items-start py-5">

      <div class="col-md-6 col-12 section-col" [ngClass]="{ 'order-md-2': i % 2 !== 0 }">
        <div class="d-flex flex-column align-items-start">
          <div class="section-content" [innerHTML]="section.text"></div>
        </div>
      </div>

      <div class="col-md-6 col-12 section-col" [ngClass]="{ 'order-md-1': i % 2 !== 0 }">
        <img [src]="getSectionImageUrl(section.image)" alt="Section illustration" class="section-image" />
      </div>

    </div>

  </div>

  <!-- Conclusion (uncomment when needed) -->
  <!-- <div class="conclusion text-center mt-5">
    <h2 class="conclusion-title">{{ 'Conclusion' | translate }}</h2>
    <p class="conclusion-text">
      {{ conclusionText }}
    </p>
  </div> -->

</div>

<app-career></app-career>